<template>
  <div>
    There are two types of balistic coefficient restituion process:
    <br />
    <ul>
      <li>
        <b>SIMPLIFIED</b>:
        <br />
        This denotes a simplified approach with rather low computational load.
        The computation of the ballistic coefficient for LEO spacecrafts is
        approximated via a linear fit on the SP propagation within each file.
      </li>
      <br />
      <li>
        <b>EXTENDED</b>:
        <br />
        This denotes an extended approach with a heavier computational time. A
        new orbit determination between each maneuvers is performed by
        restituting the ballistic coefficient corresponding to a least square
        error between the numerical propagation and the SP propagation
        measurements.
      </li>
      <br />
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipAnalysisType'
}
</script>
